const UserModel = require('common/domain/entity/user');
const UserEmailCollection = require('common/domain/collection/user-email');
const BlobCollection = require('common/domain/collection/blob');
const BlobSelectorView = require('common/ui/view/blob/selector');
const imageHelper = require('common/ui/template/helper/image');
const ModalBaseView = require('common/ui/view/modal/base');
const ModalView = require('common/ui/view/modal/index');
const UserEmailListView = require('common/ui/view/modal/user-email-list');
const UserAPI = require('common/infra/api/user');
const Template = require('common/ui/template/modal/user-setting.hbs');
const Balus = require('common/util');
const Logger = require('common/util/logger');
const i18n = require('i18next');

require('backbone.stickit');
require('bootstrap');


module.exports = ModalBaseView.extend({
    model: UserModel,
    ui: {
        imageSelector: '.image-selector'
    },
    events: {
        'click @ui.imageSelector': 'showImageSelector'
    },
    modelEvents: {
        'change:name': 'uploadable'
    },
    bindings: {
        'input.name': 'name',
        'select.language': {
            observe: 'language',
            selectOptions: {
                collection: UserModel.languages,
                labelPath: 'label',
                valuePath: 'value'
            }
        },
        'select.theme': {
            observe: 'theme',
            selectOptions: {
                collection: [
                    {
                        label: 'Light',
                        value: 'light'
                    },
                    {
                        label: 'Dark',
                        value: 'dark'
                    }
                ],
                labelPath: 'label',
                valuePath: 'value'
            }
        },
        'input.organization': 'organization'
    },

    initialize: function(params) {
        if (params && params.user) {
            this.user = params.user;
        }

        if (params) {
            this.locationOnSuccess = params.locationOnSuccess;
        }

        this.model = new UserModel(this.user.editableAttributes());

        _.bindAll(this, 'setting', 'success', 'error', 'deleteImage');
    },

    setImage: function() {
        if(this.$('.image')) {
            this.$('.image').attr('src', imageHelper(this.model.get('image_url'), 'small'));
        }
    },

    changeDeleteImageButton: function() {
        if (this.model.get('image_url')) {
            this.$('.delete-image').show();
        } else {
            this.$('.delete-image').hide();
        }
    },

    deleteImage: function() {
        this.model.set({image_url: null});
    },

    resetModel: function() {
        this.unstickit();
        this.stopListening(this.model);
        this.model = new UserModel(this.user.editableAttributes());
        this.listenTo(this.model, 'validated:invalid', this.setErrors);
        this.listenTo(this.model, 'change', this.changeDeleteImageButton);
        this.stickit();
    },

    render: function() {
        let json = this.model.toJSON();
        json.id = this.user.id;
        this.$el.html($(Template(json)));

        this.stickit();
        this.setupModal();

        this.listenTo(this.model, 'change', this.setImage);

        this.changeDeleteImageButton();

        this.listenTo(this.model, 'change', this.changeDeleteImageButton);
        this.$('.delete-image').click(this.deleteImage);

        this.$mailMagazineReceive = this.$('input.mail_magazine_receive');

        this.emailAddressListView = new UserEmailListView({collection: this.model.getEmails()});
        this.$('.mail_address_list').html(this.emailAddressListView.render().el);

        return this;
    },

    setting: function() {
        let isValid = this.model.isValid(true);
        let isMailAddressListValid = _.all(
            this.model.getEmails().map(function(m) { return m.isValid(true); })
        );

        if(!isValid || !isMailAddressListValid) {
            Balus.logger.warn('UserSetting ValidationError:', this.model.validationError);
            return false;
        }

        let json = this.model.editableAttributes();
        json.mail_magazine_receive = this.$mailMagazineReceive.is(':checked');
        json['mail_address_list'] = this.model.getEmails().filter(function(m) {
            return m.get('mail_address').length > 0;
        }).map(function(m) {
            return m.toJSON();
        });

        UserAPI.updateLoginUser(json)
            .then(this.success)
            .catch(this.error);
    },

    success: function() {
        // locationOnSuccess が設定されていれば、そのURIに移動させる
        if (this.locationOnSuccess) {
            location.href = this.locationOnSuccess;
        } else {
            // locationOnSuccess が未指定の場合は同じURIでリロードする
            location.reload();
        }
    },

    error: function(status) {
        const xhr = status.jqXHR;
        if (xhr.responseJSON && xhr.responseJSON.type == 'DuplicateEmailError') {
            this.emailAddressCollection.each(function(m) {
                if (m && m.get('mail_address') == xhr.responseJSON.msg) {
                    m.trigger('validated:invalid', m, {
                        mail_address: 'input.user.mail_address.validation.duplicated'
                    });
                }
            });
        }
        if (xhr.responseJSON && xhr.responseJSON.type == 'InvalidUserNameError') {
            this.$('.name .alert-message').html(
                i18n.t('input.user.name.validation.invalid')
            );
        }
        Logger.error('error', xhr);
    },

    uploadable: function () {
        if(this.model.get('name')) {
            this.trigger('formFilled');
        } else {
            this.trigger('formEmpty');
        }
    },


    showImageSelector: function() {
        const blobCollection = new BlobCollection();
        const imageSelector = new ModalView({
            title: i18n.t('blobSelector.title.imageOnly'),
            bodyView: new BlobSelectorView({
                blobs: blobCollection,
                imageOnly: true,
                useUploader: true,
                blobApi: this.user.blobApi
            }),
            onChildviewSave: function() {
                this.disableButtons();
                this.getOption('bodyView').select()
                    .then((blobs) => {
                        this.trigger('selected', blobs);
                        this.hide();
                    });
            }
        });

        blobCollection.fetch({
            url: '/api/my/blobs' //Balus.url_for('api:my/blob')
        });

        this.listenTo(imageSelector, 'selected', function(blob) {
            this.model.set({image_url: blob.url()});
        });

        imageSelector.show();
    }

});



// WEBPACK FOOTER //
// ./common/ui/view/modal/user-setting.js